/**
 * Define options used to create a render target texture
 */
var RenderTargetCreationOptions = function () {
  function RenderTargetCreationOptions() {}

  return RenderTargetCreationOptions;
}();

export { RenderTargetCreationOptions };